const setModalOpenType = 'SET_MODAL_OPEN_TYPE';
const setModalCloseType = 'SET_MODAL_CLOSE_TYPE';

export {
    setModalOpenType,
    setModalCloseType
}